import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import MovieSection from "./components/MovieSection";
import { movies, faqs } from "@/mocks/movies";
import { Link } from "react-router-dom";
import { useState } from "react";

export default function Home() {
  const newMovies = movies.filter((m) => m.isNew);
  const hotMovies = movies.filter((m) => m.isHot);
  const featuredMovies = movies.filter((m) => m.isFeatured);
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const organizationJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "光棍影院",
    "url": "https://fjhongjie.cn",
    "description": "光棍影院电影大全收录最新电影免费高清资源，动作片喜剧片等海量免费影视在线观看，经典大片随时畅享。",
    "sameAs": [],
  };

  const websiteJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "光棍影院",
    "url": "https://fjhongjie.cn",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://fjhongjie.cn/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const webPageJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "光棍影院 - 首页",
    "description": "光棍影院电影大全收录最新电影免费高清资源，动作片喜剧片等海量免费影视在线观看。",
    "url": "https://fjhongjie.cn/",
  };

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />

      <Navbar />

      <main>
        <HeroSection />

        <CategoryGrid />

        <MovieSection
          title="最新上映"
          subtitle="每周更新最新电影资源"
          movies={newMovies}
          linkTo="/category/action"
          linkLabel="查看全部"
        />

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <MovieSection
              title="精选推荐"
              subtitle="编辑团队精选口碑好片"
              movies={featuredMovies}
            />
          </div>
        </section>

        <MovieSection
          title="热门排行"
          subtitle="大家都在看的电影"
          movies={hotMovies}
          linkTo="/category/comedy"
          linkLabel="查看更多"
        />

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8" style={{ fontFamily: "var(--font-heading)" }}>
              常见问题
            </h2>
            <div className="space-y-3">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
                >
                  <button
                    className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  >
                    <h4 className="text-sm font-semibold text-foreground-900 pr-4">
                      <a href="#" onClick={(e) => e.preventDefault()}>{faq.question}</a>
                    </h4>
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i
                        className={`ri-${openFaq === index ? "subtract" : "add"}-line text-foreground-500 transition-transform duration-300`}
                      ></i>
                    </div>
                  </button>
                  {openFaq === index && (
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              开启您的免费观影之旅
            </h2>
            <p className="text-sm text-foreground-500 mb-6">
              无需注册，无需付费，即刻畅享海量高清电影资源
            </p>
            <Link
              to="/category/action"
              className="inline-block px-8 py-3 bg-primary-500 text-white rounded-md font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              立即观影
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}